import { Outlet, useLocation } from "react-router-dom";
import { Heading } from "../../design/heading";
import { Navbar, NavbarItem } from "../../design/navbar";

const CustodyParentingLayout = () => {
  const { pathname } = useLocation();

  const isCurrent = (slug: string) => {
    if (slug === "") return pathname === "/custody" || pathname === "/custody/";
    return pathname.startsWith(`/custody/${slug}`);
  };

  return (
    <div className="p-6">
      <Heading>Custody & Parenting</Heading>
      <Navbar>
        <NavbarItem href="" current={isCurrent("")}>
          Summary
        </NavbarItem>
        <NavbarItem href="visitation" current={isCurrent("visitation")}>
          Visitation
        </NavbarItem>
        <NavbarItem href="holiday" current={isCurrent("holiday")}>
          Holidays
        </NavbarItem>
        <NavbarItem href="support" current={isCurrent("support")}>
          Child Support
        </NavbarItem>
        <NavbarItem href="parenting-plan" current={isCurrent("parenting-plan")}>
          Parenting Plan
        </NavbarItem>
      </Navbar>
      <Outlet />
    </div>
  );
};

export default CustodyParentingLayout;